import React, { useContext } from "react";
import { secondary } from "styles/theme";
import { DashboardContext } from "../DashboardContext";

const useDoughnutChartList = () => {
    const { correctWordsPerMinuteDoughnut, percentAccuracyDoughnut, fluencyDoughnut, fluencyReadingDoughnut, factoredPercentAccuracyDoughnut } = useContext(DashboardContext)

    const doughnutChartList = React.useMemo(
        () => [
            {
                label: "מילים נכונות לדקה",
                color: "#2085ED",
                refetch: correctWordsPerMinuteDoughnut.refetch,
                data: correctWordsPerMinuteDoughnut.data,
                loading: correctWordsPerMinuteDoughnut.isFetching
            },
            // {
            //     label: "קצב",
            //     color: secondary,
            //     refetch: fluencyDoughnut.refetch,
            //     data: fluencyDoughnut.data,
            //     loading: fluencyDoughnut.isFetching
            // },
            // {
            //     label: "דיוק",
            //     color: "#44BBA3",
            //     refetch: percentAccuracyDoughnut.refetch,
            //     data: percentAccuracyDoughnut.data,
            //     loading: percentAccuracyDoughnut.isFetching
            // },
            // {
            //     label: "דיוק משוקלל",
            //     color: "#2085ED",
            //     refetch: factoredPercentAccuracyDoughnut.refetch,
            //     data: factoredPercentAccuracyDoughnut.data,
            //     loading: factoredPercentAccuracyDoughnut.isFetching
            // },
            // {
            //     label: "שטף הקריאה",
            //     color: "#2085ED",
            //     refetch: fluencyReadingDoughnut.refetch,
            //     data: fluencyReadingDoughnut.data,
            //     loading: fluencyReadingDoughnut.isFetching
            // },

        ], [correctWordsPerMinuteDoughnut, percentAccuracyDoughnut, fluencyReadingDoughnut, fluencyDoughnut, factoredPercentAccuracyDoughnut]
    )

    return doughnutChartList
}

export default useDoughnutChartList